/**
 * @file: useLeadsList.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useInfiniteList } from '@euler/functions/useInfiniteList';
import { Lead } from '@euler/model/lead/Lead';
import { LeadListFilter, LeadSorter } from '@euler/model/lead/types';
import { useServiceFactory } from '@euler/services/factory';

export const useLeadsList = (
  filter: LeadListFilter | undefined,
  options?: { limit?: number; sorter?: LeadSorter },
) => {
  const limit = options?.limit ?? 15;
  const { sorter } = options ?? {};
  const { leadService } = useServiceFactory();
  return useInfiniteList<Lead>({
    limit,
    keyExtractor: x => x.id,
    query: async (offset: number) => {
      return await leadService.list(filter, offset, limit, sorter);
    },
  });
};
